export default {
  isConnectingDeepCloudBankAccount: false,
  isCheckingDeepCloudBankAccount: false,
  isLoginToDeepCloudBankAccount: false,
  isSyncingDeepCloudBankAccount: false,
};
